module.exports = __webpack_public_path__ + "static/I-COMM SOLUTIONS SAS - Política de Tratamiento de Datos Personales v1-cdaf2a48aeda1d2182bd85d1aefec4fb.pdf";